import { RouteRecordRaw } from 'vue-router'
import { authGuard } from '../guards/authGuard.js'
import AdminLayout from '@/shared/layouts/AdminLayout.vue'

export const paymentRoutes: RouteRecordRaw = {
  path: '/payments',
  component: AdminLayout,
  beforeEnter: authGuard,
  children: [
    {
      path: '',
      name: 'payments-summary',
      component: () => import('@/features/invoices/components/PaymentsSummary.vue'),
      meta: {
        requiresAuth: true,
        requiredRoles: ['admin'],
        layout: 'default',
        title: 'Payments',
        subtitle: 'Payment Summary',
        description: 'View and manage payment information'
      }
    }
  ]
} 